<template>
  <section class='base-header-container'>
    <header :style="{paddingBottom:paddingBottom||'20px'}">
      <span  class="jee-font-second-light"
        v-if="title">{{$t(title)}}</span>
      <div class="button-list-wrap">
        <template v-for="(item, index) in buttons">
            <el-button
              class="list-wrap-btn"
              :key="index"
              v-if="!item.btnType&&index<maxShowIndex&&!item.isHidden"
              :plain="item.plain"
              :size="item.size||'medium'"
              :type="item.plain?'': (index === 0&&!item.prim?'primary':'empty')"
              :disabled="item.disabled"
              @click="handleEvent(item.type, $event,item)">
              <jee-icon
                :iconClass="item.icon"
                :style="item.iconStyle"
                v-if="item.icon"></jee-icon>{{$t(item.text)}}
            </el-button>
            <!-- :class="item.plain?'jee-button-plain':(index===0?'':'jee-button-empty')" -->
            <jee-dropdown
              :key="index"
              v-else-if="item.btnType==='dropdown'"
              v-bind="item"
              @handleCommand="handleCommand(item.type, $event, item)"
            ></jee-dropdown>
        </template>
        <slot></slot>
      </div>
      <jee-icon :icon-class="icon"
        className="tip"
        v-if="showAlertIcon&&showType === 'click'"
        @click="showAlert = !showAlert"
      />
       <jee-popover style="margin-left:8px;margin-bottom:8px" v-if="showAlertIcon&&showType === 'hover'" v-bind="popoverData"/>
    </header>
    <el-collapse-transition>
      <div v-show="showAlertIcon && showAlert && showType === 'click'">
        <el-alert
          :title="$t(content)"
          type="warning"
          show-icon
          @close="showAlert = false"
        ></el-alert>
      </div>
    </el-collapse-transition>
    <div>
  </div>
  </section>
</template>

<script>
export default {
  name: 'baseHeader',
  props: {
    buttons: {
      type: Array,
      default: () => []
    },
    maxShowIndex: {
      type: Number,
      default: 20
    },
    title: {
      type: String,
      default: ''
    },
    paddingBottom: {
      type: String,
      default: '20px'
    },
    showAlertIcon: {
      type: Boolean,
      default: true
    },
    content: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'caozuoshuoming1'
    },
    showType: {
      type: String,
      default: 'click'
    },
    popoverData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      show3: true,
      showAlert: true
    }
  },
  methods: {
    handleCommand (type, val, item) {
      this.$emit(`handleCommand${type}`, val, item)
    },
    handleEvent (type, e, item) {
      e.preventDefault()
      this.$emit(`handle${type}`, item)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-header-container{
  header{
    padding-bottom: 20px;
    display: flex;
    align-items: center;
    .button-list-wrap{
      padding-right: 10px;
      display: flex;
      flex-wrap: wrap;
      .jee-dropdown-container + .el-button,
      .el-button + .jee-dropdown-container,
      .jee-dropdown-container + .jee-dropdown-container{
        margin-left: 10px;
      }
    }
    .tip{
      cursor: pointer;
    }
  }
  .el-alert{
    display: flex!important;
    margin-bottom: 20px;
  }
}
</style>
